import React from 'react';
import { PropTypes } from 'prop-types';
import { useTrackingPage } from 'pages/Tracking/Tracking.hooks';
import { getContactInfoByCountry } from 'utils/contact';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import {
  actions as analyticsActions,
  constants as analyticsEvents,
} from 'state/analytics';
import { OnTruckLogo } from 'refactored/ui/icons';

const PageHeader = ({ className }) => {
  const { t } = useTranslation('Tracking');
  const dispatch = useDispatch();
  const sendEvent = (data) => dispatch(analyticsActions.sendEvent(data));

  const { data } = useTrackingPage();
  const { phone } = getContactInfoByCountry(data?.country);

  const onHeaderClick = () => {
    sendEvent(
      analyticsEvents.trackingPageOntruckLogoClick({
        orderId: data.id,
      })
    );
  };

  return (
    <div className={className} data-testid="page_header">
      <a
        target="_blank"
        href="https://ontruck.com"
        rel="noreferrer"
        onClick={onHeaderClick}
      >
        <OnTruckLogo />
      </a>
      {phone && (
        <p
          data-testid="page_header_contact-us"
          className="page-header__contact-us"
        >
          {t('contact_us', { phone })}
        </p>
      )}
    </div>
  );
};

PageHeader.propTypes = {
  className: PropTypes.string,
};

PageHeader.defaultProps = {
  className: '',
};

export default PageHeader;
